import { DocumentData } from "@king-ict/eupisi-ui/models";

import { TownCodeBook } from "../../models/Town";

export interface InstitutionLocation {
  id: number;
  locationDetailId: number,
  locationTypeId: 1 | 2 | 3;
  locationType: string;
  town: TownCodeBook;
  address: string;
  activityState: LocationState;
  deleteState: LocationDeleteState;
  deactivateDate?: Date,
  locationUsageAgreement?: DocumentData;
  locationMinimumRequirementSolution?: DocumentData;
}

export enum LocationState {
  Active = 1,
  Deactivated = 2
}

export enum LocationDeleteState {
  None = 0,
  CannotDelete = 1,
  Deleted = 2
}

export const institutionLocationInitial = (): InstitutionLocation => {
  return {
    id: 0,
    locationDetailId: 0,
    address: "",
    locationTypeId: 1,
    locationType: "",
    activityState: 1,
    town: { id: 0, name: "", countyId: 0, countyName: "", municipalityId: 0, municipalityName: "" },
    deleteState: LocationDeleteState.None,
    deactivateDate: undefined,
    locationUsageAgreement: undefined,
    locationMinimumRequirementSolution: undefined
  }
}